import styled from "styled-components";

export const Container = styled.div`
  background: #8c1d1d;
  width: 100vw;
  height: 100vh;
`;

export const MainContent = styled.main``;
